import { render, staticRenderFns } from "./MassMediaMobile.vue?vue&type=template&id=94578bba&scoped=true&"
import script from "./MassMediaMobile.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MassMediaMobile.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MassMediaMobile.vue?vue&type=style&index=0&id=94578bba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94578bba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94578bba')) {
      api.createRecord('94578bba', component.options)
    } else {
      api.reload('94578bba', component.options)
    }
    module.hot.accept("./MassMediaMobile.vue?vue&type=template&id=94578bba&scoped=true&", function () {
      api.rerender('94578bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/pressa/components/mobile/MassMediaMobile.vue"
export default component.exports